import React from "react";
import "./Recipients.css";
import { SERVER_ADDRESS } from "../../../constants";
import AdminRecipient from "../AdminRecipient/AdminRecipient";

class Recipients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pending: [],
            active: []
        };

        this.pullPending = this.pullPending.bind(this);
        this.pullActive = this.pullActive.bind(this);
        this.renderPending = this.renderPending.bind(this);
        this.renderActive = this.renderActive.bind(this);
        this.approve = this.approve.bind(this);
        this.markPaid = this.markPaid.bind(this);
    }

    componentDidMount() {
        this.pullPending();
        this.pullActive();
    }

    async pullPending() {
        return fetch(`${SERVER_ADDRESS}/users/pending`, {
            headers: {
                "content-type": "application/json",
                "accept": "application/json"
            }
        }).then(response => {
            return response.json();
        }).then(users => {
            if(users[0]) {
                let filteredUsers = users.filter(user => {
                    if(user.email === "rae@kidsinseats.org") {
                        return false;
                    }
                    return true;
                })
                this.setState({pending: filteredUsers});
            } else {
                this.setState({pending: []})
            }
        })
    }

    async pullActive() {
        return fetch(`${SERVER_ADDRESS}/users/active`, {
            headers: {
                "content-type": "application/json",
                "accept": "application/json"
            }
        }).then(response => {
            return response.json();
        }).then(users => {
            if(users[0]) {
                this.setState({active: users});
            } else {
                this.setState({active: []})
            }
        })
    }

    async approve(id) {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/users/${id}/approve`, {
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                this.pullPending();
                this.pullActive();
            }
        } catch(error) {
            console.log(error);
        }
    }

    async markPaid(id) {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/users/${id}/paid`, {
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(!result) {
                throw Error("Unable to update payment");
            }
        } catch(error) {
            console.log(error);
        }
    }

    renderPending() {
        let returned;
        if(this.state.pending[0]) {
            returned = this.state.pending.map(user => {
                return <AdminRecipient key={user._id} approve={this.approve} recipient={user}/>
            })
        } else {
            returned = <p>No pending recipients to display.</p>
        }
        return returned;
    }

    renderActive() {
        let returned;
        if(this.state.active[0]) {
            returned = this.state.active.map(user => {
                return <AdminRecipient markPaid={this.markPaid} key={user._id} recipient={user}/>
            })
        } else {
            returned = <p>No active recipients to display.</p>
        }
        return returned;
    }

    render() {
        return (
            <div id="recipients-page">
                <div className="recipients-container" id="pending">
                    <h2>Pending Recipients</h2>
                    {this.renderPending()}
                </div>
                <div className="recipients-container" id="active-recipients">
                    <h2>Active Recipients</h2>
                    {this.renderActive()}
                </div>
            </div>
        )
    }
}

export default Recipients;